module.exports = __webpack_public_path__ + "static/favicon.6c9cb8e2.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.ico
// module id = 318
// module chunks = 114276838955818